import React from "react";

import { CheckIcon } from "@heroicons/react/outline";
import Image from "next/image";

import Link from "next/link";

import EnerfloBestInShow2024 from "public/images/enerflo-2024-top-products-best-in-show-residential.png";
import EnerfloBestInShow2025 from "public/images/solar-power-world-2025-top-products-best-in-show-residential-enerflo.png";

import Button from "components/button";
import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { sendAnalyticEvent } from "components/layout/page/use-page";

import { sectionIds } from "./section-ids";

const sections = [
  {
    title: "Integrated Tools & Apps",
    id: sectionIds.integratedTools,
  },
  {
    title: "Solar Sales Process (Front End)",
    id: sectionIds.integratedTools,
  },
  {
    title: "Virtual Sales Rep (VSR)",
    id: sectionIds.vsr,
  },
  {
    title: "Integrated Solar Design",
    id: sectionIds.vsr,
  },
  {
    title: "Integrated Solar Financing",
    id: sectionIds.financing,
  },
  {
    title: "Solar Contracting",
    id: sectionIds.financing,
  },
  {
    title: "Solar Customer Portals",
    id: sectionIds.customerPortals,
  },
  {
    title: "Solar Install Tracker (Back End)",
    id: sectionIds.customerPortals,
  },
  {
    title: "Reporting & Analytics",
    id: sectionIds.reporting,
  },
  {
    title: "Customer Support",
    id: sectionIds.reporting,
  },
];

const BestInShowImages = () => (
  <div className="flex gap-x-10 gap-y-4 md:flex-col lg:flex-row items-center justify-center mt-6 md:mt-0 xs:col-span-2 sm:col-span-1">
    <div>
      <Link href="/resources/enerflo-wins-solar-power-worlds-2025-best-in-show-top-product-award-residential">
        <a className="inline-block md:w-4/5 lg:w-auto">
          <Image
            src={EnerfloBestInShow2025}
            alt="Enerflo Best In Show Award 2025"
            title="Enerflo Best In Show Award 2025"
            height={150}
            width={150}
          />
        </a>
      </Link>
    </div>

    <div>
      <Link href="/resources/enerflo-wins-solar-power-world-2024-residential-best-in-show">
        <a className="inline-block md:w-4/5 lg:w-auto">
          <Image
            src={EnerfloBestInShow2024}
            alt="Enerflo Best In Show Award 2024"
            title="Enerflo Best In Show Award 2024"
            height={150}
            width={150}
          />
        </a>
      </Link>
    </div>
  </div>
);

const FeatureItem = ({ children, id }: { children: string; id: string }) => (
  <li className="text-left">
    <Button
      variant="link"
      color="dark"
      href={`#${id}`}
      className="inline-flex gap-2"
      onClick={() => sendAnalyticEvent("Engagement Button", "Buttons", `Jump to ${children}`)}
    >
      <div className="inline-block p-0.5 h-5 w-5 rounded-full shadow-md bg-primary text-white shrink-0">
        <CheckIcon />
      </div>
      <p>{children}</p>
    </Button>
  </li>
);

const title = "Enerflo Operating System (OS) Features & Capabilities Overview";

const FeaturesOverview = () => {
  const middleIndex = Math.ceil(sections.length / 2);
  return (
    <div className="bg-gray-100">
      <HeroSection title={title} id={sectionIds.features}>
        <HeroSection.Content className="space-y-10">
          <header className="text-center mb-12">
            <HeroSection.Tagline className="text-primary mb-8">{title}</HeroSection.Tagline>
            <Heading tag="h2" className="mb-6 max-w-4xl mx-auto">
              <span className="text-navy-dark">Every Step of the Residential Solar Project Lifecycle</span>{" "}
              <span className="text-primary">— in One System.</span>
            </Heading>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              From the first door knock to Permission to Operate (PTO), every function runs on the same infrastructure
              layer. No manual data entry. No manual handoffs. No lost data. No excuses.
            </p>
          </header>

          <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-4 items-center max-w-6xl mx-auto">
            <ul className="space-y-4">
              {sections.slice(0, middleIndex).map(section => (
                <FeatureItem key={section.title} id={section.id}>
                  {section.title}
                </FeatureItem>
              ))}
            </ul>
            <ul className="space-y-4">
              {sections.slice(middleIndex).map(section => (
                <FeatureItem key={section.title} id={section.id}>
                  {section.title}
                </FeatureItem>
              ))}
            </ul>
            <BestInShowImages />
          </div>
        </HeroSection.Content>
      </HeroSection>
    </div>
  );
};

export default FeaturesOverview;
